<section id="services" class="services-section section-padding">
  <div class="container">

    <!-- Section Header -->
    <div class="section-header reveal-on-scroll">
      <span class="subtitle">OUR SERVICES</span>
      <h2 class="title">BUILT AROUND THE WAY YOU LIVE</h2>
      <div class="gold-divider"></div>
      <p class="description">
        Whether you're starting from scratch, rebuilding on your existing block or transforming your current home, we're
        here to guide you through the process.
      </p>
    </div>

    <!-- 3 Services Grid -->
    <div class="services-grid">
      @for (serv of services(); track serv.id; let i = $index) {
      <div class="service-card reveal-on-scroll" [class]="'delay-' + (i + 1)" (click)="openServiceModal(serv)">
        <div class="card-img-wrap">
          <img [src]="serv.image" [alt]="serv.title">
          <div class="overlay-gradient"></div>
          <div class="card-badge">ARCHITECTURAL BUILD</div>
        </div>

        <div class="card-content">
          <h3 class="card-title">{{ serv.title }}</h3>
          <p class="card-desc">{{ serv.shortDescription }}</p>

          <div class="card-footer">
            <span class="link-arrow">
              {{ serv.linkText }}
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </span>
          </div>
        </div>
      </div>
      }
    </div>

  </div>

  <!-- Full Architectural Showcase Modal Popups -->
  @if (activeServiceId(); as activeId) {
  <div class="service-modal-backdrop" (click)="closeServiceModal()">
    <div class="service-modal-dialog" (click)="$event.stopPropagation()">

      <button class="modal-close-btn" (click)="closeServiceModal()" aria-label="Close modal">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>

      <!-- ==================== 1. CUSTOM NEW HOMES POPUP ==================== -->
      @if (activeId === 'serv-1') {
      <div class="service-popup-content">

        <!-- Hero Header Banner -->
        <div class="popup-hero" style="background-image: url('/assets/images/custom_new_homes.png');">
          <div class="hero-overlay"></div>
          <div class="hero-text-wrap">
            <span class="hero-tag">CUSTOM HOMES</span>
            <h1 class="hero-title font-serif">CUSTOM HOMES.<br>BUILT AROUND YOU.</h1>
            <p class="hero-sub">
              We design and build bespoke homes across Sydney that reflect your lifestyle, your block and your future.
              From concept to completion, we bring experience, creativity and attention to detail to every custom home
              we build.
            </p>
            <div class="hero-btn-group">
              <button (click)="bookServiceConsultation('Custom New Homes Inquiry')" class="btn-gold">
                START YOUR PROJECT
              </button>
              <button (click)="scrollToProjects()" class="btn-outline-white">
                VIEW OUR PROJECTS
              </button>
            </div>
          </div>
        </div>

        <!-- 6 Feature Pillars Bar -->
        <div class="feature-pillars-bar">
          <div class="pillar-box">
            <div class="p-icon">🎨</div>
            <div class="p-info">
              <h4>BESPOKE DESIGN</h4>
              <p>A home designed around your lifestyle.</p>
            </div>
          </div>
          <div class="pillar-box">
            <div class="p-icon">🏆</div>
            <div class="p-info">
              <h4>EXPERIENCED TEAM</h4>
              <p>25+ years of construction experience.</p>
            </div>
          </div>
          <div class="pillar-box">
            <div class="p-icon">✔️</div>
            <div class="p-info">
              <h4>QUALITY ASSURED</h4>
              <p>Selected trades & premium finishes.</p>
            </div>
          </div>
          <div class="pillar-box">
            <div class="p-icon">💬</div>
            <div class="p-info">
              <h4>CLEAR COMMUNICATION</h4>
              <p>Informed at every stage of build.</p>
            </div>
          </div>
          <div class="pillar-box">
            <div class="p-icon">🤝</div>
            <div class="p-info">
              <h4>PERSONALISED SERVICE</h4>
              <p>Dedicated team from start to finish.</p>
            </div>
          </div>
          <div class="pillar-box">
            <div class="p-icon">🏠</div>
            <div class="p-info">
              <h4>BUILT FOR LIFE</h4>
              <p>Homes built to stand the test of time.</p>
            </div>
          </div>
        </div>

        <!-- Middle Section: A Home That Reflects You -->
        <div class="popup-body-section">
          <div class="split-content-grid">
            <div class="text-col">
              <span class="small-badge">DESIGNED AROUND YOU</span>
              <h2 class="section-title font-serif">A HOME THAT REFLECTS YOU.</h2>
              <p class="body-p">
                Your home should be as unique as you are. We take the time to understand how you live, what matters most
                and how your home can support your lifestyle now and in the future. From contemporary family homes to
                statement architectural designs, we create homes that are functional, beautiful and built to last.
              </p>

              <div class="checklist-grid">
                <div class="check-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C5A265" stroke-width="2.5">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  <span>Bespoke floor plans</span>
                </div>
                <div class="check-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C5A265" stroke-width="2.5">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  <span>Thoughtful design and space planning</span>
                </div>
                <div class="check-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C5A265" stroke-width="2.5">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  <span>Premium finishes and inclusions</span>
                </div>
                <div class="check-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C5A265" stroke-width="2.5">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  <span>Energy-efficient and future-focused</span>
                </div>
              </div>

              <button (click)="bookServiceConsultation('Custom New Homes')" class="btn-gold cta-btn">
                TALK TO OUR TEAM
              </button>
            </div>

            <div class="image-col">
              <div class="img-frame">
                <img src="/assets/images/interior_living.jpg" alt="Custom Luxury Living Interior Sydney">
              </div>
            </div>
          </div>

          <!-- Process Timeline Section -->
          <div class="process-section">
            <h3 class="process-heading font-serif">OUR CUSTOM HOME PROCESS</h3>
            <div class="process-gold-divider"></div>
            <div class="timeline-steps-grid">
              <div class="step-card">
                <span class="step-num">01</span>
                <h4>CONSULTATION</h4>
                <p>We get to know you, your block and your vision.</p>
              </div>
              <div class="step-card">
                <span class="step-num">02</span>
                <h4>DESIGN</h4>
                <p>We create a concept that captures your lifestyle & preferences.</p>
              </div>
              <div class="step-card">
                <span class="step-num">03</span>
                <h4>PLANNING</h4>
                <p>We refine the design, prepare documentation & finalise selections.</p>
              </div>
              <div class="step-card">
                <span class="step-num">04</span>
                <h4>APPROVALS</h4>
                <p>We manage council approvals and all required documentation.</p>
              </div>
              <div class="step-card">
                <span class="step-num">05</span>
                <h4>CONSTRUCTION</h4>
                <p>Our experienced team brings your home to life with precision.</p>
              </div>
              <div class="step-card">
                <span class="step-num">06</span>
                <h4>HANDOVER</h4>
                <p>We walk you through your completed home and hand over the keys.</p>
              </div>
            </div>
          </div>

        </div>

      </div>
      }

      <!-- ==================== 2. KNOCK DOWN & REBUILD POPUP ==================== -->
      @if (activeId === 'serv-2') {
      <div class="service-popup-content">

        <!-- Hero Header Banner -->
        <div class="popup-hero" style="background-image: url('/assets/images/knock_down_and rebuild.png');">
          <div class="hero-overlay"></div>
          <div class="hero-text-wrap">
            <span class="hero-tag">KNOCK DOWN & REBUILD</span>
            <h1 class="hero-title font-serif">LOVE THE LOCATION.<br>BUILD THE HOME YOU WANT.</h1>
            <p class="hero-sub">
              A knock down and rebuild gives you the opportunity to stay in the neighbourhood you love while creating a
              brand new custom home designed around your lifestyle.
            </p>
            <div class="hero-btn-group">
              <button (click)="bookServiceConsultation('Knock Down & Rebuild Inquiry')" class="btn-gold">
                START YOUR PROJECT
              </button>
              <button (click)="scrollToProjects()" class="btn-outline-white">
                VIEW OUR PROJECTS
              </button>
            </div>
          </div>
        </div>

        <!-- 5 Feature Pillars Bar -->
        <div class="feature-pillars-bar cols-5">
          <div class="pillar-box">
            <div class="p-icon">📍</div>
            <div class="p-info">
              <h4>PREMIUM LOCATIONS</h4>
              <p>Stay in the area you love.</p>
            </div>
          </div>
          <div class="pillar-box">
            <div class="p-icon">🏠</div>
            <div class="p-info">
              <h4>CUSTOM DESIGNED</h4>
              <p>A home designed around your lifestyle.</p>
            </div>
          </div>
          <div class="pillar-box">
            <div class="p-icon">💰</div>
            <div class="p-info">
              <h4>BETTER VALUE</h4>
              <p>More home, more value on existing block.</p>
            </div>
          </div>
          <div class="pillar-box">
            <div class="p-icon">✔️</div>
            <div class="p-info">
              <h4>MODERN COMFORT</h4>
              <p>New home, new standards.</p>
            </div>
          </div>
          <div class="pillar-box">
            <div class="p-icon">👥</div>
            <div class="p-info">
              <h4>EXPERIENCED TEAM</h4>
              <p>We guide you at every step.</p>
            </div>
          </div>
        </div>

        <!-- Middle Section: Is Knock Down & Rebuild Right For You -->
        <div class="popup-body-section">
          <div class="split-content-grid">
            <div class="text-col">
              <h2 class="section-title font-serif">IS KNOCK DOWN & REBUILD RIGHT FOR YOU?</h2>
              <div class="gold-line"></div>
              <p class="body-p">
                Knock down and rebuild is a popular choice for homeowners who love their location but need a home that
                better suits their lifestyle today.
              </p>

              <div class="checklist-vertical">
                <div class="check-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C5A265" stroke-width="2.5">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  <span>Outgrown your current home</span>
                </div>
                <div class="check-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C5A265" stroke-width="2.5">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  <span>Outdated floor plan or poor layout</span>
                </div>
                <div class="check-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C5A265" stroke-width="2.5">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  <span>Want a brand new modern home</span>
                </div>
                <div class="check-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C5A265" stroke-width="2.5">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  <span>Increase the value of your property</span>
                </div>
                <div class="check-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C5A265" stroke-width="2.5">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  <span>Utilise your land more effectively</span>
                </div>
              </div>

              <button (click)="bookServiceConsultation('Knock Down & Rebuild')" class="btn-gold cta-btn">
                TALK TO OUR TEAM
              </button>
            </div>

            <!-- Before & After Comparison Showcase -->
            <div class="image-col">
              <div class="ba-showcase-container">
                <!-- Main / After Image (Big image in background) -->
                <div class="ba-main-card">
                  <img src="/assets/images/knock_down_and rebuild.png" alt="New Custom Modern Home After Rebuild"
                    class="ba-main-img">
                </div>

                <!-- Overlapping / Before Image (Small image on left) -->
                <div class="ba-overlay-card">
                  <img src="/assets/images/knock_down_and rebuild1.png" alt="Existing Home Before Rebuild"
                    class="ba-overlay-img">
                  <div class="ba-arrow-badge">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2.5"
                      stroke-linecap="round" stroke-linejoin="round">
                      <line x1="5" y1="12" x2="19" y2="12" />
                      <polyline points="12 5 19 12 12 19" />
                    </svg>
                  </div>
                </div>
              </div>

              <!-- Bottom Label: FROM THIS > TO THIS -->
              <div class="ba-footer-labels">
                <span class="ba-label-text">FROM THIS</span>
                <svg class="ba-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C5A265"
                  stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="9 18 15 12 9 6" />
                </svg>
                <span class="ba-label-text">TO THIS</span>
              </div>
            </div>
          </div>

          <!-- Process Timeline Section -->
          <div class="process-section">
            <h3 class="process-heading font-serif">OUR KNOCK DOWN & REBUILD PROCESS</h3>
            <div class="process-gold-divider"></div>
            <div class="timeline-steps-grid">
              <div class="step-card">
                <span class="step-num">01</span>
                <h4>CONSULTATION</h4>
                <p>We understand your goals, your block and your vision.</p>
              </div>
              <div class="step-card">
                <span class="step-num">02</span>
                <h4>FEASIBILITY & SITE REVIEW</h4>
                <p>We assess your block, council requirements and potential.</p>
              </div>
              <div class="step-card">
                <span class="step-num">03</span>
                <h4>DESIGN & PLANNING</h4>
                <p>We design a custom home tailored to your lifestyle and budget.</p>
              </div>
              <div class="step-card">
                <span class="step-num">04</span>
                <h4>APPROVALS</h4>
                <p>We manage council approvals and all documentation.</p>
              </div>
              <div class="step-card">
                <span class="step-num">05</span>
                <h4>DEMOLITION & CONSTRUCTION</h4>
                <p>Demolition is followed by a carefully managed build by our team.</p>
              </div>
              <div class="step-card">
                <span class="step-num">06</span>
                <h4>HANDOVER</h4>
                <p>We complete, inspect and handover your brand new home.</p>
              </div>
            </div>
          </div>

        </div>

      </div>
      }

      <!-- ==================== 3. DUPLEX DESIGNS POPUP ==================== -->
      @if (activeId === 'serv-3') {
      <div class="service-popup-content">

        <!-- Hero Header Banner -->
        <div class="popup-hero" style="background-image: url('/assets/images/custom_new_homes.jpg');">
          <div class="hero-overlay"></div>
          <div class="hero-text-wrap">
            <span class="hero-tag">MODERN DUPLEX DESIGNS</span>
            <h1 class="hero-title font-serif">MODERN DUPLEX DESIGNS.<br>STYLE, VALUE & FUNCTIONALITY</h1>
            <p class="hero-sub">
              Considering a duplex build? Ambition Built specializes in creating modern, stylish duplex homes that
              maximize space, value and liveability.
            </p>
            <div class="hero-btn-group">
              <button (click)="bookServiceConsultation('Duplex Designs Inquiry')" class="btn-gold">
                START YOUR DUPLEX PROJECT
              </button>
              <button (click)="scrollToProjects()" class="btn-outline-white">
                VIEW OUR PROJECTS
              </button>
            </div>
          </div>
        </div>

        <!-- 3 Feature Pillars Bar -->
        <div class="feature-pillars-bar cols-3">
          <div class="pillar-box">
            <div class="p-icon">📈</div>
            <div class="p-info">
              <h4>Maximise Your Investment</h4>
              <p>Perfect for income generation or multi-generational living.</p>
            </div>
          </div>
          <div class="pillar-box">
            <div class="p-icon">🏛️</div>
            <div class="p-info">
              <h4>Contemporary Design</h4>
              <p>Sleek duplexes that make a statement in your neighborhood.</p>
            </div>
          </div>
          <div class="pillar-box">
            <div class="p-icon">🏘️</div>
            <div class="p-info">
              <h4>Flexible Living Options</h4>
              <p>Separate homes under one roof for versatile living.</p>
            </div>
          </div>
        </div>

        <!-- Middle Section: Modern Duplex Architecture -->
        <div class="popup-body-section">
          <div class="split-content-grid">
            <div class="text-col">
              <h2 class="section-title font-serif">MODERN DUPLEX ARCHITECTURE, BUILT FOR YOUR LIFESTYLE</h2>
              <div class="gold-line"></div>
              <p class="body-p subtitle-p font-serif">
                Is a duplex the right choice for your needs?
              </p>

              <div class="checklist-desc">
                <div class="desc-item">
                  <span class="bullet-dot">▪</span>
                  <div class="d-text">
                    <strong>Investment Opportunity</strong>: Great potential for additional income or accommodating
                    extended families.
                  </div>
                </div>
                <div class="desc-item">
                  <span class="bullet-dot">▪</span>
                  <div class="d-text">
                    <strong>Modern Living Design</strong>: Stylish, functional layouts maximizing space and comfort.
                  </div>
                </div>
                <div class="desc-item">
                  <span class="bullet-dot">▪</span>
                  <div class="d-text">
                    <strong>Shared Living & Independence</strong>: Ideal for multi-generational living or dual
                    occupancy.
                  </div>
                </div>
                <div class="desc-item">
                  <span class="bullet-dot">▪</span>
                  <div class="d-text">
                    <strong>Future Flexibility</strong>: Versatile options for long-term growth and lifestyle changes.
                  </div>
                </div>
              </div>

              <button (click)="bookServiceConsultation('Duplex Designs')" class="btn-gold cta-btn">
                TALK TO OUR TEAM
              </button>
            </div>

            <!-- Duplex Architecture Showcase -->
            <!-- Before & After Comparison Showcase -->
            <div class="image-col">
              <div class="ba-showcase-container">
                <!-- Main / After Image (Big image in background) -->
                <div class="ba-main-card">
                  <img src="/assets/images/duplex2.png" alt="New Custom Modern Home After Rebuild" class="ba-main-img">
                </div>

                <!-- Overlapping / Before Image (Small image on left) -->
                <div class="ba-overlay-card">
                  <img src="/assets/images/duplex1.png" alt="Existing Home Before Rebuild" class="ba-overlay-img">
                  <div class="ba-arrow-badge">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2.5"
                      stroke-linecap="round" stroke-linejoin="round">
                      <line x1="5" y1="12" x2="19" y2="12" />
                      <polyline points="12 5 19 12 12 19" />
                    </svg>
                  </div>
                </div>
              </div>

              <!-- Bottom Label: FROM THIS > TO THIS -->
              <div class="ba-footer-labels">
                <span class="ba-label-text">FROM THIS</span>
                <svg class="ba-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C5A265"
                  stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="9 18 15 12 9 6" />
                </svg>
                <span class="ba-label-text">TO THIS</span>
              </div>
            </div>
          </div>

          <!-- Process Timeline Section -->
          <div class="process-section">
            <h3 class="process-heading font-serif">OUR DUPLEX BUILD PROCESS</h3>
            <div class="process-gold-divider"></div>
            <div class="timeline-steps-grid">
              <div class="step-card">
                <span class="step-num">01</span>
                <h4>CONSULTATION</h4>
                <p>We discuss your vision, goals and budget.</p>
              </div>
              <div class="step-card">
                <span class="step-num">02</span>
                <h4>FEASIBILITY SITE REVIEW</h4>
                <p>We assess site potential and council requirements.</p>
              </div>
              <div class="step-card">
                <span class="step-num">03</span>
                <h4>DESIGN & PLANNING</h4>
                <p>We tailor duplex designs for your lifestyle.</p>
              </div>
              <div class="step-card">
                <span class="step-num">04</span>
                <h4>APPROVALS</h4>
                <p>We manage all permits and approvals.</p>
              </div>
              <div class="step-card">
                <span class="step-num">05</span>
                <h4>DEMOLITION & CONSTRUCTION</h4>
                <p>Expert build executed by our experienced team.</p>
              </div>
              <div class="step-card">
                <span class="step-num">06</span>
                <h4>HANDOVER</h4>
                <p>Inspect and handover your completed new duplex.</p>
              </div>
            </div>
          </div>

        </div>

      </div>
      }

    </div>
  </div>
  }
</section>